export default __webpack_public_path__ + "static/media/image-ph-health-home-m@3x.1b66d477.png";